import { useAtom, useAtomValue } from 'jotai'
import PricePerToken from 'src/common/components/PricePerToken/PricePerToken'
import useUpdateTradeAmounts from '../hooks/useUpdateTradeAmounts'
import {
  buyTokenAtom,
  limitOrderOptionsAtom,
  pricePerUnitAtom,
  sellTokenAmountAtom,
  sellTokenAtom,
} from '../stores/trade-store'
import useTradePageState from '../hooks/useTradePageState'

const TradePricePerToken = () => {
  const { isLimitMode } = useTradePageState()

  const sellToken = useAtomValue(sellTokenAtom)
  const buyToken = useAtomValue(buyTokenAtom)

  const pricePerUnit = useAtomValue(pricePerUnitAtom)
  const sellTokenAmount = useAtomValue(sellTokenAmountAtom)

  const [limitOfferOptions, setLimitOfferOptions] = useAtom(
    limitOrderOptionsAtom
  )

  const {
    updatePercentage,
    updatePricePerUnit,
    swapPricePerUnit,
    priceSwapped,
    updateSellAmount,
    updatePercentageType,
  } = useUpdateTradeAmounts(isLimitMode)

  const toggleDynamic = (checked: boolean) => {
    setLimitOfferOptions(v => ({ ...v, dynamic: checked }))
    if (checked && isLimitMode) {
      updateSellAmount(sellTokenAmount)
    }
  }

  if (!sellToken || !buyToken) return null

  return (
    <PricePerToken
      sellToken={sellToken}
      buyToken={buyToken}
      price={pricePerUnit}
      percentage={limitOfferOptions.percentage}
      percentageType={limitOfferOptions.percentageType}
      isDynamic={limitOfferOptions.dynamic}
      isSwappedPrice={priceSwapped}
      showOfferTakingType={isLimitMode}
      showPercentage={isLimitMode}
      onChangePercentage={updatePercentage}
      onChangePrice={updatePricePerUnit}
      swapPrice={swapPricePerUnit}
      onChangeSellAmount={updateSellAmount}
      onChangeDynamic={toggleDynamic}
      onChangePercentageType={updatePercentageType}
    />
  )
}

export default TradePricePerToken
